import React from 'react';
import { useObjectFit } from '@netc/hooks';
import Cloudinary from '@services/CloudinaryService';
const Image = ({ alt, className = '', height = null, image, ratio = null, width, options = {}, cdn, loading = 'eager', ...otherProps }) => {
    if (cdn) {
        const imageUrl1x = Cloudinary.url(image, {
            ...options,
            aspectRatio: ratio || 0,
            height: height || 0,
            width,
        });
        const imageUrl2x = Cloudinary.url(image, {
            ...options,
            aspectRatio: ratio || 0,
            dpr: 2,
            height: height || 0,
            width,
        });
        // Explicitly type the ref as HTMLImageElement
        const imgRef = useObjectFit();
        return (React.createElement("img", { ref: imgRef, ...otherProps, alt: alt, className: `${className} js-object-fit`, src: imageUrl1x, srcSet: `${imageUrl1x} 1x, ${imageUrl2x} 2x`, loading: loading }));
    }
    else {
        return (React.createElement("img", { ...otherProps, alt: alt, className: `${className} js-object-fit`, src: `${image}?width=${width}` }));
    }
};
export default Image;
